import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import Auth from '@aws-amplify/auth'

import awsconfig from './aws-exports.js'
import SmallButton from '@/components/buttons/SmallButton.vue'
import IxRouterLink from '@/components/navigation/IxRouterLink.vue'
import snippets from '@/content/snippets.js'
import constants from '@/constants.js'

import langs from '@/data/langs'
import ixrouter from '@/components/navigation/ixrouter.js'
import kk from '@/constants.js'

import loadScript from 'load-script2'

import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents)

Vue.component('small-button', SmallButton)
Vue.component('ix-router-link', IxRouterLink)
Vue.prototype.$nippets = snippets
Vue.prototype.$k = constants
Vue.prototype.$ixr = ixrouter

let gscript = null

Auth.configure(awsconfig)

async function handleLoad (path) {
  if(store.state.lang !== 'CN'){
    if(gscript === null){
      gscript = await loadScript('https://www.googletagmanager.com/gtag/js?id=UA-8046818-26')
      console.log('loaded gscript')
    }
    
    
    window.dataLayer = window.dataLayer || [];
    window.gtag = function (){
      window.dataLayer.push(arguments);
    }
    window.gtag('js', new Date());
    window.gtag('config', 'UA-8046818-26', {'page_path': path});
    
  }
  
}

router.beforeEach((to, from, next) => {
  //clear metatags before each route
  console.log('be to', to.path)
  kk.setMetatags('IllustrationX','')
  if(to.path.indexOf('not-found') < 0){
    if(to.params.lang) {
      if(!langs.navlangs.includes(to.params.lang)){
        let path = to.path.split('/').slice(2).join('/')
        store.commit('setLang', 'UK')
        next(path)
        return
      }
      else {
        console.log('doing set Lang')
        store.commit('setLang', to.params.lang.toUpperCase())
      }
    }
    else {
      console.log('looking for lang in path', to.path)
      let pts = to.path.split('/')
      if(pts.length > 1){
        if(langs.navlangs.includes(pts[1])){
          store.commit('setLang', pts[1].toUpperCase())
        }
        else {
          store.commit('setLang', 'UK')
        }
      }
      else {
        store.commit('setLang', 'uk')
      }
    }
  }
  handleLoad(to.path)
  console.log('about to next, path',to.path)
  next()
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
